<template>
  <div class="app-container">
    <!-- 顶部工具栏 -->
    <div class="sw-toolbar">
      <el-input v-model="keyword" class="sw-search" placeholder="搜索敏感词" clearable @keyup.enter.native="searchWords" @clear="searchWords">
        <i slot="prefix" class="el-input__icon el-icon-search" />
      </el-input>
      <el-button type="primary" @click="openModal()"><i class="el-icon-plus"></i> 新增</el-button>
    </div>

    <!-- 列表 -->
    <el-table :data="words" v-loading="loading" border style="width:100%">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="word" label="敏感词" min-width="160" />
      <el-table-column prop="category" label="分类" width="100" />
      <el-table-column label="触发动作" width="120" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.action === 'TRANSFER' ? 'danger' : 'primary'" size="small">{{ scope.row.action }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="80" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="small">{{ scope.row.status === 1 ? '启用' : '停用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="openModal(scope.row)">编辑</el-button>
          <el-button type="text" size="small" style="color:#F56C6C" @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
      <template slot="empty">暂无敏感词</template>
    </el-table>
    <el-pagination
      class="sw-pagination"
      layout="total, prev, pager, next"
      :current-page="page"
      :page-size="20"
      :total="total"
      @current-change="onPageChange"
    />

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="editing ? '编辑敏感词' : '新增敏感词'" :visible.sync="modalOpen" width="480px">
      <el-form ref="formRef" :model="form" :rules="rules" label-position="top">
        <el-form-item label="敏感词" prop="word">
          <el-input v-model="form.word" />
        </el-form-item>
        <el-form-item label="分类" prop="category">
          <el-input v-model="form.category" />
        </el-form-item>
        <el-form-item label="触发动作" prop="action">
          <el-select v-model="form.action" class="full-width">
            <el-option label="转人工" value="TRANSFER" />
            <el-option label="替换" value="REPLACE" />
            <el-option label="拦截" value="BLOCK" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status" class="full-width">
            <el-option label="启用" :value="1" />
            <el-option label="停用" :value="0" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="modalOpen = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listSensitiveWords, createSensitiveWord, updateSensitiveWord, deleteSensitiveWord } from '@/api/customerService/sensitive'

export default {
  name: 'CustomerServiceSensitiveWordList',
  data() {
    return {
      words: [],
      total: 0,
      page: 1,
      keyword: '',
      loading: false,
      modalOpen: false,
      editing: null,
      form: {
        word: '',
        category: '',
        action: 'TRANSFER',
        status: 1
      },
      rules: {
        word: [{ required: true, message: '请输入敏感词', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      listSensitiveWords({ keyword: this.keyword, pageNum: this.page, pageSize: 20 }).then(res => {
        if (res.code === 0) {
          this.words = res.result.list || []
          const rawTotal = res.result && res.result.total
          this.total = Number(rawTotal) > 0 ? Number(rawTotal) : 0
        }
      }).catch(() => {
        this.$message.error('加载敏感词失败')
      }).finally(() => { this.loading = false })
    },
    searchWords() {
      this.page = 1
      this.loadData()
    },
    onPageChange(p) {
      this.page = p
      this.loadData()
    },
    openModal(item) {
      this.editing = item || null
      this.form.word = item ? item.word : ''
      this.form.category = item ? item.category : ''
      this.form.action = item ? item.action : 'TRANSFER'
      this.form.status = item ? item.status : 1
      this.modalOpen = true
    },
    handleSubmit() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        if (this.editing) {
          updateSensitiveWord(this.editing.id, Object.assign({}, this.form)).then(res => {
            if (res.code === 0) {
              this.$message.success('已更新')
              this.modalOpen = false
              this.loadData()
            }
          })
        } else {
          createSensitiveWord(Object.assign({}, this.form)).then(res => {
            if (res.code === 0) {
              this.$message.success('已新增')
              this.modalOpen = false
              this.loadData()
            }
          })
        }
      })
    },
    handleDelete(id) {
      this.$confirm('确定删除该敏感词？', '提示', { type: 'warning' }).then(() => {
        deleteSensitiveWord(id).then(res => {
          if (res.code === 0) {
            this.$message.success('已删除')
            this.loadData()
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped lang="scss">
.sw-toolbar { display: flex; justify-content: space-between; margin-bottom: 16px; }
.sw-search { width: 300px; }
.sw-pagination { margin-top: 16px; text-align: right; }
.full-width { width: 100%; }
</style>